/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/get_spam_results/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { engagementAppGroupIdGetSpamResultsId } from "./constants";
import type { EngagementGetSpamResultsIdResult, getEngagementGetSpamResultsIdParams } from "./types";

export const getEngagementGetSpamResultsId = reactQueryFetcherAdapter(
  engagementAppGroupIdGetSpamResultsId,
  (
    signal: AbortSignal,
    { appGroupId, id }: getEngagementGetSpamResultsIdParams
  ): Promise<EngagementGetSpamResultsIdResult> => {
    return fetch(`/engagement/${appGroupId}/get_spam_results/${id}`, "GET", {}, { signal });
  }
);
